import comp from "./AudioWaveformPlayer";
export default comp;
